// extracted by mini-css-extract-plugin
export default {"section":"partnerSites-module--section--1XlA_","image":"partnerSites-module--image--16FZ2"};